import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { BaseConfirmDialog } from './BaseConfirmDialog';
export const GetSendByEmailDialogTID = (parentTestId)=>getTestIds(parentTestId);
export const SendByEmailDialog = (props)=>{
    const { SendByEmailDialogTID } = useMemo(()=>GetSendByEmailDialogTID(), []);
    const { t: sendByEmailTexts } = useLocaleKeys('vendorOnboarding.adHocBillModal.confirmationDialogs.sendByEmail');
    const [loading, setLoading] = useState(false);
    const handleConfirm = async ()=>{
        if (loading) return;
        setLoading(true);
        const succeeded = await props.onConfirm();
        if (!succeeded) setLoading(false);
    };
    return /*#__PURE__*/ _jsx(BaseConfirmDialog, {
        testIds: SendByEmailDialogTID,
        title: sendByEmailTexts.title(),
        bodyIntro: sendByEmailTexts.bodyIntro(),
        bodyDescription: sendByEmailTexts.bodyDescription(),
        companyName: props.companyName,
        contactName: props.contactName,
        email: props.email,
        coverCreditCardFees: props.coverCreditCardFees,
        backLabel: sendByEmailTexts.backButton(),
        primaryLabel: sendByEmailTexts.sendButton(),
        loading: loading,
        onBack: props.onBack,
        onConfirm: handleConfirm
    });
};
